import MinimizedSeoLinksGrid from '@alltrails/seo/components/MinimizedSeoLinksGrid/MinimizedSeoLinksGrid';
import type { SeoLinkItem } from '@alltrails/types/SeoLinkItem';
import styles from './DesktopLinkSection.module.scss';

type DesktopLinkSectionProps = {
  title: string;
  links: SeoLinkItem[];
  isBot?: boolean;
  seoTestAddTrailsToLocationLinks?: boolean;
  seoTestAddHikingTrailsToLocationLinks?: boolean;
};

const DesktopLinkSection = ({
  title,
  links,
  isBot = false,
  seoTestAddTrailsToLocationLinks,
  seoTestAddHikingTrailsToLocationLinks
}: DesktopLinkSectionProps) => {
  return (
    <div className={styles.linkBlockColumns}>
      <MinimizedSeoLinksGrid
        title={title}
        linkItems={links}
        isBot={isBot}
        seoTestAddTrailsToLocationLinks={seoTestAddTrailsToLocationLinks}
        seoTestAddHikingTrailsToLocationLinks={seoTestAddHikingTrailsToLocationLinks}
      />
    </div>
  );
};

export default DesktopLinkSection;
